module.exports = __webpack_public_path__ + "static/media/YB5F03_1.94c785e2.jpg";